module.exports = __webpack_public_path__ + "static/media/enrolled.3f5f850f.svg";